<template>
  <div class="export-pdf-container">
    <div class="box-header">
      <p class="title">
        {{
          programCategoryRating.criterion_category
            ? programCategoryRating.criterion_category.name
            : ""
        }}
      </p>
    </div>
    <div class="content">
      <table class="common-table">
        <tr class="tr-heading">
          <th>No.</th>
          <th>Criterion & Indicators</th>
          <th>Weight</th>
          <th>Minimum rating level</th>
          <th>Real data</th>
          <th>Score</th>
          <th>Awarded stars</th>
        </tr>
        <tr class="tr-main">
          <td>{{ orderNumber }}</td>
          <td>
            {{
              programCategoryRating.criterion_category
                ? programCategoryRating.criterion_category.name
                : ""
            }}
          </td>
          <td>{{ programCategoryRating.weight | formatNumber }}</td>
          <td></td>
          <td></td>
          <td>{{ programCategoryRating.score | formatNumber }}</td>
          <td>
            <p
              v-if="
                !programCategoryRating.star || programCategoryRating.star == '0'
              "
            >
              N/A
            </p>
            <img
              v-else
              class="table-star-big"
              style="max-width: 150px"
              alt=""
              :src="
                `img/icon-rating/${getCategoryStarImg(
                  programInfo.program_type_id === 1 ? 'research' : 'applied',
                  programCategoryRating.star
                )}`
              "
            />
          </td>
        </tr>
        <template
          v-for="(criteria, criteriaIndex) in programCategoryRating.criteria"
        >
          <tr
            class="tr-sub"
            :key="'tr-sub' + criteriaIndex"
            v-if="(orderNumber === 6 || orderNumber === 2) && criteriaIndex < 7"
          >
            <td class="order-number">
              {{ orderNumber }}.{{ criteriaIndex + 1 }}
            </td>
            <td>
              <p class="table-text-big">
                {{ criteria.criterion ? criteria.criterion.name : "" }}
              </p>
              <p class="table-text-small">
                {{ criteria.criterion ? criteria.criterion.description : "" }}
              </p>
            </td>
            <td>{{ criteria.weight }}</td>
            <td>
              {{ criteria.min_point }}-{{ criteria.benchmark
              }}{{ criteria.programt }}
            </td>
            <td>{{ criteria.achievement }}</td>
            <td>{{ criteria.score }}</td>
            <td>
              <p v-if="!criteria.star || criteria.star == '0'">
                N/A
              </p>
              <img
                v-else
                class="table-star-small"
                style="max-width: 150px"
                alt=""
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    programInfo.program_type_id === 1 ? 'research' : 'applied',
                    criteria.star
                  )}`
                "
              />
            </td>
          </tr>

          <tr
            class="tr-sub"
            :key="'tr-sub' + criteriaIndex"
            v-else-if="
              orderNumber !== 6 && orderNumber !== 2 && criteriaIndex < 6
            "
          >
            <td class="order-number">
              {{ orderNumber }}.{{ criteriaIndex + 1 }}
            </td>
            <td>
              <p class="table-text-big">
                {{ criteria.criterion ? criteria.criterion.name : "" }}
              </p>
              <p class="table-text-small">
                {{ criteria.criterion ? criteria.criterion.description : "" }}
              </p>
            </td>
            <td>{{ criteria.weight | formatNumber }}</td>
            <td>
              {{ criteria.min_point }}-{{ criteria.benchmark
              }}{{ criteria.programt }}
            </td>
            <td>{{ criteria.achievement }}</td>
            <td>{{ criteria.score | formatNumber }}</td>
            <td>
              <p v-if="!criteria.star || criteria.star == '0'">
                N/A
              </p>
              <img
                v-else
                class="table-star-small"
                style="max-width: 150px"
                alt=""
                :src="
                  `img/icon-rating/${getCategoryStarImg(
                    programInfo.program_type_id === 1 ? 'research' : 'applied',
                    criteria.star
                  )}`
                "
              />
            </td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriterionRatingHeader",
  props: {
    orderNumber: {
      type: Number
    },
    programCategoryRating: {
      type: Object
    },
    programInfo: {
      type: Object
    }
  },
  methods: {
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    },
    getCategoryPicture(orderNumber) {
      return `category${orderNumber}.png`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/program-pdf.scss";
</style>
